
import Sender from '~/api/sender';
import ScheduleRequest from '~/requests/schedule';
import { handleResponse } from 'razlet-sulu-sdk/lib/utils/helpers';
// import sulu from '~/mixins/sulu';

export default {
  name: 'schedule-page-arrival',
  layout: 'blue',
  // mixins: [sulu],
  async asyncData({redirect, route, error}) {
    const destination = route.params.departure;

    const results = await Promise.allSettled([
      Sender.get(`/asb/cities`, {params: { term:destination }}),
      Sender.get(`/asb/cities`, {params: { destination }}),
    ]);

    const [from, cities] = handleResponse(results, error);

    const departure = from.data.map(item => {
      return {
        country: item.country,
        code: item.codeEn,
        name: item.name,
      };
    })[0];

    const list = cities.data;

    if (!departure || !departure.code) redirect(301, { name: 'passazhiram-schedule' });

    return {
      departure,
      list,
    };
  },
  data() {
    return {
      request: new ScheduleRequest(),
      departure: {},
      list: [],
      loading: true,
    };
  },
  watch: {
    'request.from.code': {
      handler(value) {
        if (!value) this.$router.push({
          name: 'passazhiram-schedule', 
        });
      },
    },
    'request.to.code': {
      handler(value) {
        if (value) this.$router.push({
          name: 'passazhiram-schedule-departure-arrival', 
          params: { 
            departure: this.request.from.code || '-', 
            arrival: value, 
          },
        });
      },
    }
  },
  created() {
    this.request.from = this.departure;
    this.loading = false;
  },
  mounted() {
    this.$bus.$on('locale-changed', () => {
      this.loading = true;
      window.scrollTo(0, 0);
      this.$nuxt.refresh().then(() => {
        this.request.from = this.departure;
        this.loading = false;
      });
    });
  },
};
